import { createApi } from '@reduxjs/toolkit/query/react'
import { NetWork } from '../../../common/apiKey'
import { DELETE, GET, PATCH, POST, PUT } from '../../../common/contants'
import { axiosBaseQuery } from '../../baseQuery'

export const orderApi = createApi({
  reducerPath: 'orderApi',
  baseQuery: axiosBaseQuery,
  tagTypes: ['Order', 'OrderFast', 'DetailOrder'],
  keepUnusedDataFor: 5,
  endpoints: (builder) => ({
    getListOrder: builder.query({
      query: (params) => ({
        url: NetWork.order,
        method: GET,
        params: params
      }),
      providesTags: (result) => (result ? [{ type: 'Order', id: 'LIST' }] : [])
    }),
    getOrderById: builder.query({
      query: (params: { orderId: number }) => ({
        url: NetWork.orderId(params.orderId),
        method: GET
      }),
      providesTags: (result) => (result ? [{ type: 'DetailOrder', id: 'DETAIL' }] : [])
    }),
    getOrderByKey: builder.query({
      query: (params) => ({
        url: NetWork.orderKey,
        method: GET,
        params: params
      }),
      providesTags: (result) => (result ? [{ type: 'DetailOrder', id: 'DETAIL' }] : [])
    }),
    addOrder: builder.mutation({
      query: (data) => ({
        url: NetWork.order,
        method: POST,
        data: data
      }),
      invalidatesTags: [{ type: 'Order', id: 'LIST' }]
    }),
    updateOrder: builder.mutation({
      query: (data) => ({
        url: NetWork.orderId(data.id),
        method: PUT,
        data: data
      }),
      invalidatesTags: [{ type: 'Order', id: 'LIST' }]
    }),
    updateStatusOrder: builder.mutation({
      query: (data: { id: number; params: { statusOrder: string } }) => ({
        url: NetWork.orderId(data.id),
        method: PATCH,
        params: data.params
      }),
      invalidatesTags: [{ type: 'DetailOrder', id: 'DETAIL' }]
    }),
    updateStatusApprovalOrder: builder.mutation({
      query: (data: { id: number; params: { statusApproval: string; reasonCancel?: string } }) => ({
        url: NetWork.orderApproval(data.id),
        method: PUT,
        params: data.params
      }),
      invalidatesTags: [{ type: 'DetailOrder', id: 'DETAIL' }]
    }),
    deleteOrder: builder.mutation({
      query: (data: { ids: Array<number | string> }) => ({
        url: NetWork.order,
        method: DELETE,
        data: data
      }),
      invalidatesTags: [{ type: 'Order', id: 'LIST' }]
    }),
    //THÊM NHANH
    getListFastOrder: builder.query({
      query: (data) => ({
        url: NetWork.orderFast + '/' + data.uuid,
        method: GET,
        params: data.params
      }),
      providesTags: (result) => (result ? [{ type: 'OrderFast', id: 'LIST' }] : [])
    }),
    getFastOrderById: builder.query({
      query: (params: { orderId: number }) => ({
        url: NetWork.orderId(params.orderId),
        method: GET
      })
    }),
    addFastOrder: builder.mutation({
      query: (data) => ({
        url: NetWork.orderFast,
        method: POST,
        data: data
      }),
      invalidatesTags: [{ type: 'OrderFast', id: 'LIST' }]
    }),
    updateFastOrder: builder.mutation({
      query: (data) => ({
        url: NetWork.orderFastId(data.id),
        method: PUT,
        data: data
      }),
      invalidatesTags: [{ type: 'OrderFast', id: 'LIST' }]
    }),
    deleteFastOrder: builder.mutation({
      query: (data: { ids: Array<number | string> }) => ({
        url: NetWork.order,
        method: DELETE,
        data: data
      }),
      invalidatesTags: [{ type: 'OrderFast', id: 'LIST' }]
    }),
    connectFastOrder: builder.mutation({
      query: (data) => ({
        url: NetWork.orderFastConnectOrder(data.id),
        method: POST,
        data: data
      }),
      invalidatesTags: [{ type: 'OrderFast', id: 'LIST' }]
    }),
    //Thêm ảnh
    uploadFileOrder: builder.mutation({
      query: (data) => ({
        url: NetWork.uploadOrder(data.path),
        method: POST,
        data: data.values,
        headers: { 'Content-Type': 'multipart/form-data' }
      })
    }),
    exportByOrderKT: builder.query({
      query: (params) => ({
        url: NetWork.reportKT,
        method: GET,
        params,
        responseType: 'blob' // 👈 Cực kỳ quan trọng!
      }),
      /* eslint-disable @typescript-eslint/no-explicit-any */
      transformResponse: (response: any) => response
      /* eslint-enable @typescript-eslint/no-explicit-any */
    }),
    //Lock order
    changeLockOrder: builder.mutation({
      query: (data: { orderId: number; params: { isLock: boolean } }) => ({
        url: NetWork.lockOrder(data.orderId, data.params.isLock),
        method: PATCH,
        params: data.params
      })
    }),
    //Bảng kê
    getCheckListOrder: builder.query({
      query: (params) => ({
        url: NetWork.reportCheckList,
        method: GET,
        params: params
      })
      // providesTags: (result) => (result ? [{ type: 'Order', id: 'LIST' }] : [])
    }),
    getCheckListDetailOrder: builder.query({
      query: (params) => ({
        url: NetWork.reportCheckListDetail,
        method: GET,
        params: params
      })
      // providesTags: (result) => (result ? [{ type: 'Order', id: 'LIST' }] : [])
    })
  })
})

// Export hooks for usage in functional components
export const {
  useGetListOrderQuery,
  useDeleteOrderMutation,
  useAddOrderMutation,
  useGetOrderByIdQuery,
  useUpdateOrderMutation,
  useAddFastOrderMutation,
  useDeleteFastOrderMutation,
  useGetFastOrderByIdQuery,
  useGetListFastOrderQuery,
  useUpdateFastOrderMutation,
  useConnectFastOrderMutation,
  useUploadFileOrderMutation,
  useUpdateStatusOrderMutation,
  useUpdateStatusApprovalOrderMutation,
  useGetOrderByKeyQuery,
  useLazyGetOrderByKeyQuery,
  useLazyExportByOrderKTQuery,
  useChangeLockOrderMutation,
  useGetCheckListOrderQuery,
  useGetCheckListDetailOrderQuery
} = orderApi
